import React from 'react';
import Button from '../../forms/Button';
import Form from '../forms/FullScreenForm';
import LoadingWrapper from '../../hocs/LoadingWrapper';
import SelectField from '../../forms/SelectField';

const SelectForm = props => {
    const canSubmit = !!props.selected;
    return (
        <Form
            onSubmit={props.onSubmit}
            canSubmit={canSubmit}
            header="Select Event"
            body={
                <LoadingWrapper show={!props.eventsFetched} label="Loading Events">
                    <SelectField
                        label="Event"
                        id="ckp-id-events-select"
                        value={props.selected}
                        onChange={props.onEventSelect}
                        items={props.selectableEvents}
                        name="event"
                    />
                </LoadingWrapper>
            }
            footer={<Button inactive={!canSubmit} label="Select" />}
        />
    );
};

export default SelectForm;
